
export const INFO_TYPE_HOME = 'HOME';
export const INFO_TYPE_NO = 'NO';
export const INFO_TYPE_OBJECT = 'OBJECT';
export const INFO_TYPE_OBJECT_CREATE = 'OBJECT_CREATE';
export const INFO_TYPE_OBJECT_EDIT = 'OBJECT_EDIT';
export const INFO_TYPE_OBJECT_LIST = 'OBJECT_LIST';
